import script from "./PeripheralEquipmentColumn.vue?vue&type=script&setup=true&lang=ts"
export * from "./PeripheralEquipmentColumn.vue?vue&type=script&setup=true&lang=ts"

import "./PeripheralEquipmentColumn.vue?vue&type=style&index=0&id=99b22570&lang=css"

const __exports__ = script;

export default __exports__